import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../i18n';
import { getBonusTiers } from '../api';
import PublicNav from '../components/PublicNav';

const TIER_DISCOUNTS = {
    public: 0,
    reseller: 0.40,
    partner: 0.50,
    elite: 0.60,
};

const c = {
    root: { minHeight: '100vh', background: '#050810', color: '#f1f5f9', fontFamily: '"Segoe UI", system-ui, sans-serif' },
    nav:  { position: 'sticky', top: 0, zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 48px', background: 'rgba(5,8,16,0.92)', backdropFilter: 'blur(16px)', borderBottom: '1px solid rgba(29,78,216,0.15)', gap: 12 },
    logo: { display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', color: '#f1f5f9', fontWeight: 800, fontSize: 20 },
    logoIcon: { width: 32, height: 32, borderRadius: '50%', background: 'linear-gradient(135deg,#1d4ed8,#06b6d4)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 },
    main: { maxWidth: 1100, margin: '0 auto', padding: '80px 48px' },
    hero: { textAlign: 'center', marginBottom: 80 },
    h1:   { fontSize: 48, fontWeight: 900, marginBottom: 16, letterSpacing: '-1px' },
    sub:  { fontSize: 18, color: '#64748b', maxWidth: 600, margin: '0 auto' },
    secH: { fontSize: 13, fontWeight: 700, color: '#1d4ed8', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 12, display: 'block' },
    secTitle: { fontSize: 32, fontWeight: 800, marginBottom: 8, letterSpacing: '-0.5px' },
    secSub: { fontSize: 15, color: '#64748b', marginBottom: 24 },
    // toggle
    toggleWrap: { display: 'flex', alignItems: 'center', gap: 4, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: 4, marginBottom: 32 },
    toggleBtn: (active) => ({ padding: '8px 20px', borderRadius: 8, border: 'none', fontWeight: 600, fontSize: 14, cursor: 'pointer', transition: 'all 0.2s', background: active ? 'linear-gradient(135deg,#1d4ed8,#06b6d4)' : 'none', color: active ? '#fff' : '#64748b' }),
    resellerBadge: { display: 'inline-block', marginLeft: 8, padding: '2px 8px', borderRadius: 100, background: 'rgba(29,78,216,0.2)', color: '#60a5fa', fontSize: 11, fontWeight: 700 },
    // service grid
    svcGrid: { display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12 },
    svcCard: { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 14, padding: '20px 18px' },
    svcName: { fontSize: 15, fontWeight: 700, marginBottom: 4 },
    svcDesc: { fontSize: 13, color: '#64748b', marginBottom: 12, lineHeight: 1.6 },
    svcPriceRow: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' },
    svcPrice: { fontSize: 13, fontWeight: 700, color: '#60a5fa' },
    svcPriceOld: { fontSize: 12, color: '#334155', textDecoration: 'line-through' },
    svcSaveBadge: { fontSize: 10, padding: '1px 6px', borderRadius: 100, background: 'rgba(29,78,216,0.15)', color: '#60a5fa', fontWeight: 700 },
    tag: { display: 'inline-block', padding: '2px 8px', borderRadius: 100, background: 'rgba(6,182,212,0.12)', color: '#06b6d4', fontSize: 10, fontWeight: 600, marginRight: 4, marginTop: 4 },
    // plans
    planGrid: { display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 24, marginTop: 24, alignItems: 'stretch' },
    planCard: { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 18, padding: '28px 24px', display: 'flex', flexDirection: 'column', position: 'relative' },
    planHot:  { border: '1px solid rgba(29,78,216,0.5)', background: 'rgba(29,78,216,0.06)' },
    planBadge:{ position:'absolute',top:-14,left:'50%',transform:'translateX(-50%)',background:'linear-gradient(135deg,#1d4ed8,#06b6d4)',color:'#fff',fontSize:11,fontWeight:700,padding:'3px 14px',borderRadius:100,whiteSpace:'nowrap' },
    planName: { fontSize: 20, fontWeight: 800, marginBottom: 4 },
    planDesc: { fontSize: 12, color: '#64748b', marginBottom: 16 },
    planAmt:  { fontSize: 46, fontWeight: 900, letterSpacing: '-2px', lineHeight: 1 },
    planPer:  { fontSize: 13, color: '#64748b' },
    planFeat: { listStyle: 'none', padding: 0, margin: '18px 0 20px', display: 'flex', flexDirection: 'column', gap: 8, flex: 1 },
    planFi:   { fontSize: 13, color: '#94a3b8', display: 'flex', gap: 8 },
    btn:      { padding: '12px 0', borderRadius: 10, fontWeight: 700, fontSize: 14, cursor: 'pointer', border: 'none', textAlign: 'center', background: 'linear-gradient(135deg,#1d4ed8,#06b6d4)', color: '#fff' },
    btnOut:   { padding: '12px 0', borderRadius: 10, fontWeight: 600, fontSize: 14, cursor: 'pointer', border: '1.5px solid rgba(29,78,216,0.4)', textAlign: 'center', background: 'none', color: '#60a5fa' },
    divider: { border: 'none', borderTop: '1px solid rgba(255,255,255,0.06)', margin: '80px 0' },
    // bonus
    bonusTierRow: { display: 'flex', alignItems: 'center', gap: 12, padding: '14px 18px', background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 12, marginBottom: 8 },
    bonusMin: { fontSize: 22, fontWeight: 900, color: '#f1f5f9', minWidth: 80 },
    bonusPct: { fontSize: 20, fontWeight: 800, color: '#60a5fa' },
    // discount table
    discountWrap: { background: 'rgba(29,78,216,0.05)', border: '1px solid rgba(29,78,216,0.15)', borderRadius: 16, padding: '48px' },
    tbl:     { width: '100%', borderCollapse: 'collapse', marginTop: 28 },
    tblTh:   { padding: '12px 16px', background: 'rgba(255,255,255,0.04)', color: '#60a5fa', fontSize: 12, textAlign: 'left', borderBottom: '1px solid rgba(255,255,255,0.06)' },
    tblTd:   { padding: '12px 16px', borderBottom: '1px solid rgba(255,255,255,0.04)', fontSize: 14 },
    tblHigh: { background: 'rgba(29,78,216,0.08)' },
    footer:  { borderTop: '1px solid rgba(255,255,255,0.06)', padding: '28px 48px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginTop: 80 },
    footerLink: { color: '#64748b', textDecoration: 'none', fontSize: 13 },
};

// Icon + description per task_type (for DB-fetched services)
const TASK_META = {
    like_post:                   { icon: '❤️',  desc: 'Real likes on photos, carousels and reels from authentic accounts' },
    like_reel:                   { icon: '❤️',  desc: 'Dedicated reel-safe like method with unique resourceId click' },
    like_story:                  { icon: '❤️',  desc: 'Heart reactions on stories, boosts story engagement score' },
    follow_user:                 { icon: '👥',  desc: 'Real followers with posts, bio and authentic activity history' },
    watch_user_stories:          { icon: '👁️', desc: 'Real accounts watch your stories — signals sustained engagement' },
    watch_story_and_visit_profile:{ icon: '👁️', desc: 'Story view + profile visit in a single interaction for compound effect' },
    watch_specific_reel:         { icon: '🎬',  desc: 'Genuine reel views with realistic watch time — key for Explore reach' },
    visit_profile:               { icon: '🔍',  desc: 'Real accounts visit and scroll your profile for 30–60 seconds' },
    save_post:                   { icon: '📌',  desc: 'The strongest engagement signal in the Instagram algorithm' },
    repost_post:                 { icon: '🔄',  desc: 'Real accounts repost your content to their stories — secondary reach' },
    comment_post:                { icon: '💬',  desc: 'AI-generated contextual comments, naturally written and unique' },
    comment_reel:                { icon: '💬',  desc: 'AI-crafted reel comments — unique and contextually relevant' },
    watch_post_and_follow:       { icon: '📷',  desc: 'View post then follow — compound engagement at lower combined cost' },
    watch_reel_and_follow:       { icon: '🎬',  desc: 'Watch reel then follow — maximum profile growth signal per action' },
    like_and_follow:             { icon: '⚡',  desc: 'Like the post and follow the author — double signal in a single visit' },
    like_save_and_follow:        { icon: '⚡',  desc: 'Like, save and follow — triple compound signal, strongest per-action ROI' },
    like_and_save:               { icon: '⚡',  desc: 'Like and save the post — two strongest engagement signals combined in one visit' },
    like_comment_and_follow:     { icon: '⚡',  desc: 'Like, AI comment and follow — quality compound signal at lower combined cost' },
    like_and_comment:            { icon: '⚡',  desc: 'Like and AI comment on the post — compound quality engagement at reduced cost' },
    watch_story:                 { icon: '👁️', desc: 'Watch a specific story via direct link — verified view' },
    like_all_stories:            { icon: '❤️',  desc: 'Watch all stories and randomly like some — organic compound signal' },
    react_story:                 { icon: '😍',  desc: 'Watch all stories and randomly react with emoji — authentic engagement' },
    reply_story:                 { icon: '💬',  desc: 'Watch all stories and randomly reply with AI text — highest engagement' },
    react_specific_story:        { icon: '😍',  desc: 'React to a specific story with emoji — guaranteed delivery' },
    reply_specific_story:        { icon: '💬',  desc: 'Reply to a specific story with AI text — guaranteed delivery' },
    like_recent_post:            { icon: '❤️',  desc: 'Browse latest posts and randomly like — organic profile engagement' },
    save_recent_post:            { icon: '🔖',  desc: 'Browse latest posts and randomly save — strongest algorithm signal' },
    repost_recent_post:          { icon: '🔁',  desc: 'Browse latest posts and share to stories — viral amplification' },
    comment_recent_post:         { icon: '✍️',  desc: 'AI-generated comment on a recent post — natural and contextual' },
    react_story_dm:              { icon: '😊',  desc: 'React to a Story with emoji via Direct Message — works on all devices' },
    reply_story_dm:              { icon: '💌',  desc: 'Reply to a Story with AI-generated text via Direct Message' },
    send_dm:                     { icon: '📨',  desc: 'Send a personalized AI Direct Message to the target profile' },
    send_dm_enhanced:            { icon: '📨',  desc: 'Custom DMs: your example messages rewritten by AI, adapted to the recipient' },
    click_story_link:            { icon: '🔗',  desc: '⚠️ Place the link sticker in the CENTER of the Story (not edges/corners). Real accounts click it — AI vision detects position automatically' },
    story_poll_vote:             { icon: '🗳️', desc: 'Real accounts vote on your Story poll — boosts interactive engagement and algorithm reach' },
    story_slider_vote:           { icon: '🎚️', desc: 'Real accounts react to your Story slider sticker — strong interactive engagement signal' },
    story_question_reply:        { icon: '❓',  desc: 'Real accounts reply to your Story question sticker with AI-generated answers' },
    like_comment:                { icon: '👍',  desc: 'Real accounts like a comment on your post — boosts comment visibility and signals authentic approval' },
    watch_user_reels:            { icon: '🎬',  desc: 'Real accounts watch all recent Reels from your profile — compound reel reach signal' },
    share_specific_story:        { icon: '🔄',  desc: 'Share a specific Story to follower feeds — direct viral amplification' },
    share_all_stories:           { icon: '🔄',  desc: 'Share all active Stories to follower feeds — maximum viral reach' },
    share_post_to_story:         { icon: '📤',  desc: 'Share your Post to real accounts\' Stories — exposes your content to new audiences' },
    share_reel_to_story:         { icon: '📤',  desc: 'Share your Reel to real accounts\' Stories — drives organic traffic to your profile' },
};

// One representative service per task_type (prefer ALL/Mixed gender)
function deduplicateServices(services) {
    const seen = {};
    for (const s of services) {
        if (s.task_type === 'subscription') continue;
        const key = s.task_type;
        if (!seen[key] || s.gender === 'ALL') {
            seen[key] = s;
        }
    }
    return Object.values(seen);
}

// Subscription plans (per 1000 accounts pricing)
const PLANS_IT = [
    { name: '1 Month', price_per_1k: 650, perAccount: 0.65, duration: 30, hot: false, cta: 'Get Started →', savePct: null,
      features: ['Daily likes on your posts', 'Follow your profile', 'Daily story views', 'Profile visits & reel views', 'Real verified accounts', 'Duration: 30 days'] },
    { name: '3 Months', price_per_1k: 1700, perAccount: 0.57, duration: 90, hot: true, cta: 'Start Growing →', savePct: 13,
      features: ['Daily likes on your posts', 'Follow your profile', 'Daily story views', 'Profile visits & reel views', 'Real verified accounts', 'Duration: 90 days'] },
    { name: '6 Months', price_per_1k: 2900, perAccount: 0.48, duration: 180, hot: false, cta: 'Get Started →', savePct: 26,
      features: ['Daily likes on your posts', 'Follow your profile', 'Daily story views', 'Profile visits & reel views', 'Real verified accounts', 'Duration: 180 days'] },
];

export default function Pricing() {
    const navigate = useNavigate();
    const { t, fmtEur, currency } = useLang();
    const [tier, setTier] = useState('public');
    const [bonusTiers, setBonusTiers] = useState([]);
    const [dbServices, setDbServices] = useState([]);

    const p = t('pricing');
    const common = t('common');

    useEffect(() => {
        getBonusTiers().then(data => {
            if (Array.isArray(data)) setBonusTiers(data);
        }).catch(() => {});
        fetch('/public/services')
            .then(r => r.json())
            .then(data => { if (Array.isArray(data)) setDbServices(data); })
            .catch(() => {});
    }, []);

    // Price formatting helpers — prices shown per 1000 actions
    // DB returns price_per_1k as string from JSON → parse to float first
    const fmtRate = (price_per_1k) => {
        const p = parseFloat(price_per_1k) || 0;
        const final = p * (1 - (TIER_DISCOUNTS[tier] || 0));
        return fmtEur(final);
    };

    const fmtPlanPrice = (price_eur) => {
        const final = price_eur * (1 - (TIER_DISCOUNTS[tier] || 0));
        return fmtEur(final);
    };

    const displayServices = deduplicateServices(dbServices);

    return (
        <div style={c.root}>
            {/* NAV */}
            <PublicNav />

            <div className="og-pricing-main" style={c.main}>
                {/* HERO */}
                <div style={c.hero}>
                    <span style={c.secH}>{p.heroLabel}</span>
                    <h1 className="og-pricing-h1" style={c.h1}>{p.heroTitle}</h1>
                    <p style={c.sub}>{p.heroSub}</p>
                    {/* Currency note */}
                    {currency === 'USD' && (
                        <div style={{ marginTop: 12, fontSize: 12, color: '#334155' }}>{common.currencyNote}</div>
                    )}
                </div>

                {/* TIER TOGGLE */}
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 48, padding: '0 8px' }}>
                    <div className="og-tier-toggle" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, auto)', gap: 4, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: 4 }}>
                        <button style={c.toggleBtn(tier === 'public')} onClick={() => setTier('public')}>
                            {p.togglePublic}
                        </button>
                        <button style={c.toggleBtn(tier === 'reseller')} onClick={() => setTier('reseller')}>
                            Reseller
                            <span style={{ ...c.resellerBadge, ...(tier === 'reseller' ? { background: 'rgba(255,255,255,0.25)', color: '#fff' } : {}) }}>−40%</span>
                        </button>
                        <button style={c.toggleBtn(tier === 'partner')} onClick={() => setTier('partner')}>
                            Partner
                            <span style={{ ...c.resellerBadge, ...(tier === 'partner' ? { background: 'rgba(255,255,255,0.25)', color: '#fff' } : { background: 'rgba(139,92,246,0.2)', color: '#a78bfa' }) }}>−50%</span>
                        </button>
                        <button style={c.toggleBtn(tier === 'elite')} onClick={() => setTier('elite')}>
                            Elite
                            <span style={{ ...c.resellerBadge, ...(tier === 'elite' ? { background: 'rgba(255,255,255,0.25)', color: '#fff' } : { background: 'rgba(245,158,11,0.2)', color: '#f59e0b' }) }}>−60%</span>
                        </button>
                    </div>
                </div>

                {tier !== 'public' && (
                    <div style={{ background: tier === 'elite' ? 'rgba(245,158,11,0.08)' : tier === 'partner' ? 'rgba(139,92,246,0.08)' : 'rgba(29,78,216,0.08)', border: `1px solid ${tier === 'elite' ? 'rgba(245,158,11,0.2)' : tier === 'partner' ? 'rgba(139,92,246,0.2)' : 'rgba(29,78,216,0.2)'}`, borderRadius: 12, padding: '14px 20px', marginBottom: 32, display: 'flex', alignItems: 'center', gap: 12, fontSize: 14, flexWrap: 'wrap' }}>
                        <span style={{ fontSize: 20 }}>{tier === 'elite' ? '⚫' : tier === 'partner' ? '🟣' : '🟢'}</span>
                        <span style={{ color: tier === 'elite' ? '#f59e0b' : tier === 'partner' ? '#a78bfa' : '#60a5fa', flex: 1 }}>
                            {tier === 'elite'
                                ? (p.tierBannerElite || 'Elite tier preview — up to 60% off. By invitation only for high-volume partners.')
                                : tier === 'partner'
                                ? (p.tierBannerPartner || 'Partner tier — 50% off all services. Reach €500/month or claim an Early Partner slot.')
                                : (p.resellerBannerFull || 'Reseller tier — 40% off all services. Available to all registered resellers.')}
                        </span>
                        <a href="/partner"
                            style={{ padding: '8px 16px', background: tier === 'elite' ? 'rgba(245,158,11,0.2)' : tier === 'partner' ? '#8b5cf6' : 'linear-gradient(135deg,#1d4ed8,#06b6d4)', color: tier === 'elite' ? '#f59e0b' : '#fff', border: 'none', borderRadius: 9, fontWeight: 700, fontSize: 13, cursor: 'pointer', textDecoration: 'none', whiteSpace: 'nowrap' }}>
                            {p.tierBannerLink || 'Learn more about our Partner Program →'}
                        </a>
                    </div>
                )}

                {/* SERVICES GRID */}
                <section>
                    <span style={c.secH}>{p.singleLabel}</span>
                    <div style={c.secTitle}>{p.singleTitle}</div>
                    <p style={{ ...c.secSub, marginBottom: 32 }}>{p.singleSub}</p>

                    <div className="og-grid-3" style={c.svcGrid}>
                        {displayServices.length === 0 ? (
                            <div style={{ gridColumn: '1/-1', textAlign: 'center', color: '#475569', padding: '40px 0' }}>Loading services…</div>
                        ) : displayServices.map(s => {
                            const fallbackMeta = TASK_META[s.task_type] || { icon: '⭐', desc: s.name };
                            const i18nMeta = p.task_meta?.[s.task_type];
                            const icon = i18nMeta?.icon || fallbackMeta.icon;
                            const desc = i18nMeta?.desc || fallbackMeta.desc;
                            const publicPrice = fmtEur(parseFloat(s.price_per_1k) || 0);
                            const finalPrice  = fmtRate(s.price_per_1k);
                            // Use translated name if available, otherwise strip gender suffix
                            const displayName = i18nMeta?.name
                                || s.name.replace(/\s*-\s*(Male\+Female|Male|Female)$/, '').replace(/\s*-\s*(ALL)$/, '').replace('IG ', '');
                            const catTag = s.category ? s.category.replace(/^.*?—\s*/, '') : '';
                            return (
                                <div key={s.service_id} style={c.svcCard}>
                                    <div style={{ fontSize: 22, marginBottom: 8 }}>{icon}</div>
                                    <div style={c.svcName}>{displayName}</div>
                                    <div style={c.svcDesc}>{desc}</div>
                                    <div style={c.svcPriceRow}>
                                        <span style={c.svcPrice}>{finalPrice} / 1000</span>
                                        {tier !== 'public' && (
                                            <><span style={c.svcPriceOld}>{publicPrice}</span>
                                            <span style={c.svcSaveBadge}>−{Math.round((TIER_DISCOUNTS[tier] || 0) * 100)}%</span></>
                                        )}
                                    </div>
                                    <div style={{ marginTop: 6 }}>
                                        <span style={c.tag}>{catTag || 'Instagram'}</span>
                                        {s.min_qty && <span style={c.tag}>min {s.min_qty}</span>}
                                        <span style={{ ...c.tag, color: '#f87171', background: 'rgba(239,68,68,0.06)', border: '1px solid rgba(239,68,68,0.2)' }}>🚫 No Refill</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </section>

                {/* 2026-08-05: Subscriptions dismesse — sezione nascosta */}
                {false && (<>
                <hr style={c.divider} />
                <section id="subscription">
                    <span style={c.secH}>{p.plansLabel}</span>
                    <div style={c.secTitle}>{p.plansTitle}</div>
                    <p style={{ ...c.secSub, marginBottom: 8 }}>{p.plansSub}</p>

                    {/* Trial banner */}
                    {p.trial && (
                        <div style={{ marginTop: 16, marginBottom: 8, background: 'linear-gradient(135deg, rgba(6,182,212,0.08), rgba(29,78,216,0.12))', border: '1px solid rgba(6,182,212,0.3)', borderRadius: 14, padding: '20px 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 14 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 14, flex: 1, minWidth: 260 }}>
                                <span style={{ display: 'inline-flex', padding: '3px 10px', background: 'rgba(6,182,212,0.25)', border: '1px solid rgba(6,182,212,0.4)', borderRadius: 100, fontSize: 10, fontWeight: 800, color: '#06b6d4', letterSpacing: 1, whiteSpace: 'nowrap' }}>
                                    {p.trial.badge}
                                </span>
                                <div>
                                    <div style={{ fontSize: 15, fontWeight: 700, color: '#f1f5f9', marginBottom: 2 }}>{p.trial.title}</div>
                                    <div style={{ fontSize: 12, color: '#64748b' }}>{p.trial.desc}</div>
                                </div>
                            </div>
                            <button onClick={() => navigate('/register')} style={{ ...c.btn, padding: '10px 24px', fontSize: 13, whiteSpace: 'nowrap' }}>
                                {p.trial.cta}
                            </button>
                        </div>
                    )}

                    <div className="og-grid-3" style={c.planGrid}>
                        {PLANS_IT.map(pl => {
                            const displayPrice = fmtEur(pl.price_per_1k * (1 - (TIER_DISCOUNTS[tier] || 0)));
                            return (
                                <div key={pl.name} style={{ ...c.planCard, ...(pl.hot ? c.planHot : {}) }}>
                                    {pl.hot && <div style={c.planBadge}>Best Value{pl.savePct ? ` — Save ${pl.savePct}%` : ''}</div>}
                                    {!pl.hot && pl.savePct && (
                                        <div style={{ ...c.planBadge, background: 'rgba(6,182,212,0.8)' }}>Save {pl.savePct}%</div>
                                    )}
                                    <div style={{ ...c.planName, marginTop: pl.savePct || pl.hot ? 8 : 0 }}>{pl.name}</div>
                                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 4, marginTop: 12 }}>
                                        <span style={c.planAmt}>{displayPrice}</span>
                                    </div>
                                    <div style={{ fontSize: 13, color: '#64748b', marginBottom: 4 }}>/1,000 accounts</div>
                                    <div style={{ fontSize: 14, color: '#60a5fa', fontWeight: 600, marginBottom: 16 }}>
                                        {fmtEur(pl.perAccount * (1 - (TIER_DISCOUNTS[tier] || 0)))}/account/month
                                    </div>
                                    {tier !== 'public' && (
                                        <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8, textDecoration: 'line-through' }}>
                                            {fmtEur(pl.price_per_1k)}/1,000 accounts
                                        </div>
                                    )}
                                    <ul style={c.planFeat}>
                                        {pl.features.map(f => <li key={f} style={c.planFi}><span style={{ color: '#1d4ed8', fontWeight: 700 }}>✓</span>{f}</li>)}
                                    </ul>
                                    <button onClick={() => navigate('/register')} style={pl.hot ? c.btn : c.btnOut}>
                                        {pl.cta}
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                </section>
                </>)}

                <hr style={c.divider} />

                {/* DEPOSIT BONUSES */}
                {bonusTiers.length > 0 && (
                    <section>
                        <span style={c.secH}>{p.bonusLabel}</span>
                        <div style={c.secTitle}>{p.bonusTitle}</div>
                        <p style={{ ...c.secSub, marginBottom: 24 }}>{p.bonusSub}</p>
                        <div>
                            {bonusTiers.filter(t => t.is_active).map(tier => (
                                <div key={tier.id} style={c.bonusTierRow}>
                                    <div style={{ fontSize: 28 }}>🎁</div>
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontSize: 14, fontWeight: 700, color: '#f1f5f9' }}>{tier.label}</div>
                                        <div style={{ fontSize: 13, color: '#64748b', marginTop: 2 }}>
                                            {p.bonusMin}: <strong style={{ color: '#f1f5f9' }}>{fmtEur(Number(tier.min_amount))}</strong>
                                        </div>
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                        <div style={{ fontSize: 28, fontWeight: 900, color: '#60a5fa', letterSpacing: '-1px' }}>+{tier.bonus_pct}%</div>
                                        <div style={{ fontSize: 11, color: '#64748b' }}>{p.bonusBonus}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div style={{ marginTop: 16, padding: '14px 18px', background: 'rgba(6,182,212,0.05)', border: '1px solid rgba(6,182,212,0.15)', borderRadius: 10, fontSize: 13, color: '#64748b' }}>
                            💡 Bonuses are cumulative with volume discounts. Stack both for maximum value.
                        </div>
                    </section>
                )}

                {bonusTiers.length > 0 && <hr style={c.divider} />}

                {/* PARTNER PROGRAM CTA */}
                <section>
                    <div style={{ background: 'linear-gradient(135deg, rgba(29,78,216,0.08), rgba(139,92,246,0.08))', border: '1px solid rgba(139,92,246,0.2)', borderRadius: 20, padding: '40px 32px', textAlign: 'center' }}>
                        <span style={c.secH}>{p.partnerCtaLabel || 'RESELLER PROGRAM'}</span>
                        <div style={{ ...c.secTitle, marginBottom: 12 }}>{p.partnerCtaTitle || 'Save up to 60% on all services'}</div>
                        <p style={{ color: '#94a3b8', fontSize: 15, maxWidth: 500, margin: '0 auto 24px', lineHeight: 1.6 }}>
                            {p.partnerCtaDesc || 'Join our Partner Program and unlock exclusive discounts. Three tiers: Reseller (40%), Partner (50%), and Elite (up to 60%).'}
                        </p>
                        <a href="/partner"
                            style={{ display: 'inline-block', padding: '14px 32px', background: 'linear-gradient(135deg,#1d4ed8,#06b6d4)', color: '#fff', border: 'none', borderRadius: 12, fontWeight: 700, fontSize: 15, cursor: 'pointer', textDecoration: 'none' }}>
                            {p.partnerCtaBtn || 'View Partner Program →'}
                        </a>
                    </div>
                </section>
            </div>

            {/* FOOTER */}
            <footer style={c.footer}>
                <a style={c.logo} href="/">
                    <img src="/logo.svg" alt="OrbitGrowth" style={{ height: 28, width: 'auto', borderRadius: 6 }} />
                </a>
                <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
                    <a style={c.footerLink} href="/">{common.footer.home}</a>
                    <a style={c.footerLink} href="/api-docs">{common.footer.apiDocs}</a>
                    <a style={c.footerLink} href="/terms">{common.footer.terms}</a>
                    <a style={c.footerLink} href="/login">{common.footer.login}</a>
                    <a style={c.footerLink} href="/register">{common.footer.register}</a>
                </div>
                <span style={{ color: '#334155', fontSize: 12 }}>© {new Date().getFullYear()} OrbitGrowth</span>
                <div style={{ width: '100%', borderTop: '1px solid rgba(255,255,255,0.04)', marginTop: 8, paddingTop: 12, display: 'flex', gap: 20, justifyContent: 'center', flexWrap: 'wrap' }}>
                    <a href="https://t.me/orbitgrowth" target="_blank" rel="noopener noreferrer" style={{ color: '#60a5fa', fontSize: 12, textDecoration: 'none' }}>
                        💬 Telegram: @orbitgrowth
                    </a>
                    <span style={{ color: '#1e293b', fontSize: 12 }}>·</span>
                    <a href="mailto:orbitgrowth.staff@gmail.com" style={{ color: '#475569', fontSize: 12, textDecoration: 'none' }}>
                        ✉ orbitgrowth.staff@gmail.com
                    </a>
                </div>
            </footer>
        </div>
    );
}
